import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {VirtualScrollerComponent} from 'ngx-virtual-scroller';
import {DatePipe} from '@angular/common';
import { Medicao } from '../../models/medicao.model';

@Component({
  selector: 'app-grafico-poluente',
  templateUrl: './grafico-poluente.component.html',
  styleUrls: ['./grafico-poluente.component.scss'],
})
export class GraficoPoluenteComponent implements OnInit, AfterViewInit {
  @Input() isEscuro: boolean;
  @Input() poluente: any;
  @Input() tipoMedicao = 'I';
  @Input() medicoes: Array<Medicao>;
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;
  loading: boolean;
  indices = [];
  start: boolean;
  end: boolean;
  constructor() {
  }

  async ngAfterViewInit() {
    // const divisoria = this.indices.find(x => x.divisoria);
    // this.virtualScroller.scrollInto(divisoria, false, 20, 300);
    await this.virtualScroller.scrollToIndex(this.indices.length - 1);
    await setTimeout(async () => {
      for await (const indice of this.indices) {
        if (indice.divisoria) {
          continue;
        }
        indice.valor = indice.indiceQualidadeAr / 2;
      }
    }, 1000);
  }


  ngOnInit() {
    console.log('tipo medicao', this.tipoMedicao);
    for (const indice of this.medicoes) {
      indice.valor = 0;
      indice.dtMedicao = indice.dtMedicao.replace(/\s/g, 'T');
      const datePipe = new DatePipe('en-US');
      let diaAtual: any = this.medicoes[this.medicoes.indexOf(indice) + 1] ?
        this.medicoes[this.medicoes.indexOf(indice) + 1].dtMedicao : 0;
      const diaAnterior = indice.dtMedicao.replace(/\s/g, 'T');
      diaAtual = diaAtual ? diaAtual.replace(/\s/g, 'T') : diaAtual;

      this.indices.push(indice);
      if (diaAtual && datePipe.transform(diaAtual, 'dd') !== datePipe.transform(diaAnterior, 'dd')) {
        this.indices.push({id: 1, divisoria: true, dtMedicao: diaAtual});
      }
    }
  }

  getChange(pageInfo: any) {
    this.start = pageInfo.startIndex === 0;
    this.end = pageInfo.endIndex === (this.medicoes ? this.medicoes.length : 0);
  }

}
